/* Native dialogs keep focus management, Escape and an explicit close control. */
(() => {
  const embedDialogs = new Map();
  function embedDialog(formId) {
    if (!/^[a-zA-Z0-9]+$/.test(formId)) return null;
    if (embedDialogs.has(formId)) return embedDialogs.get(formId);
    const dialog = document.createElement('dialog');
    dialog.className = 'launch-dialog launch-notify-dialog';
    dialog.id = `LaunchNotify-${formId}`;
    dialog.setAttribute('aria-labelledby', `${dialog.id}-title`);
    const heading = document.createElement('h2');
    heading.id = `${dialog.id}-title`;
    heading.textContent = 'Avísame cuando salga';
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'launch-dialog__close';
    close.setAttribute('data-launch-dialog-close', '');
    close.setAttribute('aria-label', 'Cerrar formulario');
    close.textContent = '×';
    const loading = document.createElement('p');
    loading.className = 'launch-notify-dialog__loading';
    loading.setAttribute('role', 'status');
    loading.textContent = 'Cargando formulario…';
    const mount = document.createElement('div');
    mount.className = `klaviyo-form-${formId}`;
    const observer = new MutationObserver(() => {
      if (mount.querySelector('form, input, iframe')) {
        loading.remove();
        observer.disconnect();
      }
    });
    observer.observe(mount, { childList: true, subtree: true });
    dialog.append(close, heading, loading, mount);
    document.body.append(dialog);
    embedDialogs.set(formId, dialog);
    return dialog;
  }
  function prepareEmbeds() {
    document.querySelectorAll('[data-form-type="embed"]').forEach(button => {
      embedDialog(button.dataset.formId || button.dataset.aeNotify || '');
    });
  }
  prepareEmbeds();
  document.addEventListener('shopify:section:load', prepareEmbeds);
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-launch-dialog-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.launchDialogOpen);
      if (dialog) dialog.showModal();
      return;
    }
    const closer = event.target.closest('[data-launch-dialog-close]');
    if (closer) closer.closest('dialog').close();
    if (event.target.matches('dialog.launch-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
    const notify = event.target.closest('[data-launch-notify-open], [data-ae-notify]');
    if (!notify) return;
    const contextElement = notify.closest('[data-launch-notify]')?.querySelector('[data-launch-notify-context]');
    const context = contextElement ? JSON.parse(contextElement.textContent) : {
      product_id: notify.dataset.productId,
      product: notify.dataset.productTitle,
      url: notify.dataset.productUrl
    };
    context.variant_id = document.querySelector('[data-pdp-form] [data-variant-id]')?.value;
    context.date = new Date().toISOString();
    // The Klaviyo flow must associate this context with the submitted email.
    document.dispatchEvent(new CustomEvent('onedilemma:launch-notify', { detail: context }));
    const formId = notify.dataset.formId || notify.dataset.aeNotify;
    if (notify.dataset.formType === 'embed') {
      const dialog = embedDialog(formId);
      if (dialog) dialog.showModal();
    } else {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    }
  });
})();
